import { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AppContext from '../../../AppContext';
import { addMessage } from '../messageSlice';
import { weatherRequest } from '../../../../../utils/helpers';
import { toggleAdvertisement } from '../../../widgetSlice';

export const BotTyping = () => {
  const theme = useContext(AppContext);
  const dispatch = useDispatch();
  const botTyping = useSelector((state) => state.messageState.botTyping);
  const progress = useSelector((state) => state.messageState.progress);
  const travelInfo = useSelector((state) => state.messageState.travelInfo);
  const { advertisement } = useSelector((state) => state.widgetState);
  const [weather, setWeather] = useState(['']);

  const { botAvatar, botMsgColor, botMsgBackgroundColor } = theme;

  async function getWeather() {
    const data = await weatherRequest(travelInfo.destination);
    setWeather(data.weather);
  }
  useEffect(() => {
    progress === 'booking' && getWeather();
  }, [travelInfo]);

  useEffect(() => {
    if (botTyping && progress === 'booking') {
      const waiting = setTimeout(() => {
        dispatch(
          toggleAdvertisement({
            ...advertisement,
            booking: true
          })
        );
        dispatch(
          addMessage({
            text: 'Please wait for your results...',
            sender: 'BOT',
            type: 'text',
            ts: new Date()
          })
        );
      }, 9000);
      return () => clearTimeout(waiting);
    }
  }, [botTyping]);

  useEffect(() => {
    if (botTyping && progress === 'booking') {
      const timer = setTimeout(() => {
        dispatch(
          addMessage({
            text: "We are bringing you the best travel options based on your company's travel policy. Please wait...",
            sender: 'BOT',
            type: 'text',
            ts: new Date()
          })
        );
      }, 40000);
      return () => clearTimeout(timer);
    }
  }, [botTyping]);

  useEffect(() => {
    if (botTyping && progress === 'booking') {
      const timeouts = [];
      weather?.slice(0, 3).forEach((w, index) => {
        const timeout = setTimeout(() => {
          dispatch(
            addMessage({
              text: `
Weather at your destination
📍    ${travelInfo.destination} ${w.date}
☁️   ${w.hourly[0].weatherDesc[0].value}
🌡️    High/Low: ${w.maxtempC}°C/${w.mintempC}°C
☀️   UV Index: ${w.uvIndex}
🔍   Your search results are coming...
	`,
              sender: 'BOT',
              type: 'text',
              ts: new Date()
            })
          );
        }, (index + 1) * 25000);
        timeouts.push(timeout);
      });
      return () => timeouts.forEach((t) => clearTimeout(t));
    }
  }, [botTyping, progress, travelInfo, weather]);

  return (
    botTyping && (
      <div className="flex space-x-1">
        <div className={`flex w-5 items-end`}>
          <img
            src={
              'https://cdn-assets-cloud.frontify.com/s3/frontify-cloud-files-us/eyJwYXRoIjoiZnJvbnRpZnlcL2FjY291bnRzXC9jZFwvMTk5ODU5XC9wcm9qZWN0c1wvMjY0OTE4XC9hc3NldHNcLzNkXC80NzI1MjU4XC8xYTBhOTZiOGE0NDU0MWFiMzU1MWMxNjUyYTNlYTk4Zi0xNjAwNjU0MzU2LnN2ZyJ9:frontify:gsQ9U0DuxzszjK_ObCuu-MR2AArYhXvQVFRWSvRC5Uc?width=2400'
            }
            className={'w-5'}
            alt="Bot Logo"
          />
        </div>
        <div
          className={`flex w-fit  space-x-2 self-start whitespace-pre-line break-words rounded-bl-[5px]  rounded-tr-[14px] rounded-br-[14px] rounded-tl-[14px] py-3 px-5 text-white`}
          style={{ backgroundColor: botMsgBackgroundColor }}
        >
          <div
            className="animation-delay-32  h-[8px] w-2 animate-bounce rounded-full bg-white "
            style={{ backgroundColor: botMsgColor }}
          ></div>
          <div
            className="animation-delay-16  h-[8px] w-2 animate-bounce rounded-full bg-white"
            style={{ backgroundColor: botMsgColor }}
          ></div>
          <div
            className="h-[8px] w-2 animate-bounce rounded-full bg-white "
            style={{ backgroundColor: botMsgColor }}
          ></div>
        </div>
      </div>
    )
  );
};
